
export * from '../../frontend-js-react-web/__liferay__/exports/prop-types.js';

import __default__ from '../../frontend-js-react-web/__liferay__/exports/prop-types.js';
export default __default__;
